<template>
  <span
    :class="isBlock ? 'block' : ''"
  >
    <slot name="front-icon" />
    <SimpleLink
      v-if="isInternalLink"
      :to="shouldPushUrl ? url : `/${url}`"
      :target="blank ? '_blank' : '_self'"
      class="link"
      :class="{
        'block h-full w-full' : isBlock,
        'link--primary': type === LINK_TYPE.Primary,
        'link--no-underline': type === LINK_TYPE.NoUnderline,
        'link--secondary': type === LINK_TYPE.Secondary,
        'link--dark-no-underline': type === LINK_TYPE.Dark,
        'link--no-style': type === LINK_TYPE.NoStyle,
        'link--inherit-color': type === LINK_TYPE.InheritColor
      }"
      :aria-label="ariaLabel"
      :no-link-pointer="noLinkPointer"
      :data-gtm="gtmId"
      @link-click="$emit('link-click', $event)"
    >
      <slot>{{ text }}</slot>
    </SimpleLink>
    <ExternalLink
      v-else
      :url="url"
      :text="text"
      :blank="blank"
      :aria-label="ariaLabel"
      :data-gtm="gtmId"
      @click="$emit('link-click', $event)"
    >
      <slot>{{ text }}</slot>
    </ExternalLink>
  </span>
</template>

<script lang="ts">

import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import type { LinkType } from '~~/types/components/Link/LinkType';
import { isInspirationsBlogUrl } from '~~/helpers/isInspirationsBlogUrl/isInspirationsBlogUrl';

export default defineComponent({
  name: 'CustomLink',

  props: {
    text: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: LINK_TYPE.Primary,
      validator(value: LinkType) {

        return value && Object.values(LINK_TYPE).includes(value);

      },
    },
    blank: {
      type: Boolean,
      default: false,
    },
    isBlock: {
      type: Boolean,
      default: false,
    },
    shouldPushUrl: {
      type: Boolean,
      default: true,
    },
    ariaLabel: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
    noLinkPointer: {
      type: Boolean,
      default: false,
    },
    gtmId: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
  },
  emits: ['link-click'],
  setup(props: { url: string; }) {

    const linkContainsExpondoDotCom = props.url.includes('expondo.com');
    const linkContainsExpondoDot = props.url.includes('expondo.');
    const linkContainsExpondoSalesforce = props.url.includes('expondogmbh.my.site.com');
    const linkContainsHttp = props.url.includes('http');
    const linkContainsInspirationsBlog = isInspirationsBlogUrl(props.url);

    const isInternalLink = computed(() => {

      if (linkContainsExpondoDotCom) {

        return false;

      } else if (linkContainsInspirationsBlog) {

        return false;

      } else if (linkContainsExpondoSalesforce) {

        return false;

      } else if (linkContainsExpondoDot) {

        return true;

      } else if (linkContainsHttp) {

        return false;

      }

      return true;

    });

    return {
      LINK_TYPE,
      isInternalLink,
    };

  },
});

</script>

<style lang="scss" scoped>
.link--primary {
  @apply text-EXPONDO-secondary underline;
}

.link--secondary {
  @apply text-EXPONDO-primary-60 underline;
}

.link--no-underline {
  @apply text-EXPONDO-secondary no-underline;
}

.link--dark-no-underline {
  @apply text-EXPONDO-primary no-underline;
}

.link--no-style {
  @apply no-underline;
}

.link--inherit-color {
  @apply underline;
}
</style>
